export default __webpack_public_path__ + "static/media/men-player.f02ebfdd.jpg";